import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<mask id=\"mask0_vi\" style=\"mask-type:alpha;\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"20\" height=\"20\"><circle cx=\"10\" cy=\"10\" r=\"10\" fill=\"#D9D9D9\"></circle></mask><g mask=\"url(#mask0_vi)\"><rect width=\"20\" height=\"20\" fill=\"#DA251D\"></rect><polygon points=\"10,4.5 11.2,8.2 15.1,8.2 11.9,10.5 13.1,14.2 10,12 6.9,14.2 8.1,10.5 4.9,8.2 8.8,8.2\" fill=\"#FFCD00\"></polygon></g>", 2)
  ])))
}
export default { render: render }